import client from "./client";

const getTransactions = () => client.get("order/all/paginated?");

export default { getTransactions };
